import { render } from "./ShowError.vue?vue&type=template&id=6b727c64"
import script from "./ShowError.vue?vue&type=script&lang=js"
export * from "./ShowError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__